<template>
   <div class="seller-manage">
       <div class="opera-group">
           <a-button type="primary" @click="addItem(2,1)">添加项目</a-button>
       </div>   
       <div class="manage-table" v-if="projectDict">
           <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" :scroll="{ x: 1420 }"   :rowKey="(record,index)=>{return index}" >
               <!-- <span slot="projectNature" slot-scope="text">{{ $utils.getVal(projectDict[0].bg_project_category,text) }}</span> -->
               <span slot="analysisState" slot-scope="text">{{ text == '0'?'未分析':'已分析' }}</span>
               <span slot="projectCategoryName" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>
               <span slot="createTime" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>
               <span slot="projectName" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>
               <span slot="projectCode" slot-scope="text">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ text }}</span>
                     </template>
                     {{ text }}
                  </a-tooltip>
               </span>
               <span slot="chainState" slot-scope="text">{{ text == '0'?'未上链':'已上链' }}</span>
               <span slot="address" slot-scope="text,record">
                  <a-tooltip placement="topLeft">
                     <template slot="title">
                        <span>{{ record.cityName + record.countyName + record.townName + record.villageName }}</span>
                     </template>
                     {{ record.cityName + record.countyName + record.townName + record.villageName }}
                  </a-tooltip>
               </span>
               <template slot="action" slot-scope="text,record">
                  <div class="operate-btns">
                     <a-button type="primary" @click="addItem(record,2)">详情</a-button>
                     <a-button type="primary" :disabled="record.chainState=='1'?true:false" @click="addItem(record,3)">编辑</a-button>
                     <a-button type="primary" :disabled="record.analysisState=='1'?true:false" @click="$router.push('/analysis')">项目分析</a-button>
                     <a-button type="primary" :disabled="record.chainState=='1'?true:false">申请上链</a-button>
                     <a-button type="primary" :disabled="record.chainState=='1'?true:false" @click="deleteRecord(record)">删除</a-button>
                  </div>
               </template>
           </a-table>
       </div>   
       <dialog-manage ref="addItem" @getDataList="getDataPage"></dialog-manage>
       <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
   </div>    
</template>

<script>
import dialogManage from './mainManege.vue'
const columns = [
   {
      title: '项目编码',
      dataIndex: 'projectCode',
      width: 120,
      scopedSlots: { customRender: 'projectCode' },
   },
   {
      title: '项目名称',
      dataIndex: 'projectName',
      width: 120,
      scopedSlots: { customRender: 'projectName' },
   },
   {
      title: '类别',
      dataIndex: 'projectCategoryName',
      width: 140,
      scopedSlots: { customRender: 'projectCategoryName' },
   },
   {
      title: '地区',
      dataIndex: 'address',
      width: 150,
      scopedSlots: { customRender: 'address' },
   },
   {
      title: '项目分析状态',
      dataIndex: 'analysisState',
      width: 120,
      scopedSlots: { customRender: 'analysisState' },
   },
   {
      title: '项目上链状态',
      dataIndex: 'chainState',
      width: 100,
      scopedSlots: { customRender: 'chainState' },
   },
   {
      title: '登记时间',
      dataIndex: 'createTime',
      width: 150,
      scopedSlots: { customRender: 'createTime' },
   },
   {
      title: '操作',
      fixed: 'right',
      id:'8',
      dataIndex: 'operate',
      width: 420,
      scopedSlots: { customRender: 'action' },
   },
];
export default {
   components:{
      dialogManage
   },
   data(){
       return{
            columns:columns,
            data:[],
            projectDict:[
               {
                   bg_project_category:[]
               }
           ],
           total:1,
           params:{
              pageSize:10,
              pageNum:1
           },
           loading:false,
       }
   },
   created(){
       this.$https.get('/portal/projectDict/list').then(res=>{
            if(res.code == 200){
               this.projectDict = res.rows;
             }else{
               this.$message.info(res.msg)
            }
       })
       this.getDataList();
   },
   methods:{
      addItem(row,status){
         this.$https.get('/portal/bidding/isCertifi').then(res=>{
              if(!res){
                  row = JSON.stringify(row);
                  this.$refs.addItem.showDiolag(row,status);
              }else{
                 this.$message.info('请前往实名认证')
              }
         })

        
      },
      getList(page){
         this.params.pageNum = page;
         this.getDataList();
      },
      getDataPage(){
         this.params.pageNum = 1;
         this.getDataList();
      },
      getDataList(){
         this.loading = true;
         this.$https.get('/portal/project/projectManageList/',{params:this.params}).then(res=>{
               this.loading = false;
               if(res.code == 200){
                  this.data = res.rows;
                  this.total = Number(res.total);
               }else{
                  this.$message.error(res.msg)
               }
         }).catch(error=>{
              this.loading = false;
         })
      },
      deleteRecord(row){
         let _this = this;
         this.$confirm({
               title: '确定删除该条记录?',
               content: '',
               onOk() {
                  _this.$https.delete(`/portal/project/delete/${row.projectId}`).then(res=>{
                         if(res.code == 200){
                            _this.$message.success('删除成功');
                            _this.getDataPage();
                         }
                  }).catch(error=>{
                           _this.$message.success('删除失败');
                  })
               },
               onCancel() {},
               });
      } 
     
   }
}
</script>

<style lang="less" scoped>
.opera-group{
   margin:0 0 20px 20px;
}
.operate-btns{
   .ant-btn{
      margin-right:8px;
   }
}
</style>